import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { requestService } from '../../services/requestService'
import moment from 'moment'
import './AdminRequest.scss'
import { companyService } from '../../services/companyService'
import { IoMdClose } from 'react-icons/io'
import { Button, Spinner } from 'react-bootstrap'
import { useDebouncedCallback } from 'use-debounce'
import { conversationsService } from '../../services/conversationsService'
import { toast } from 'react-toastify'

export default function AdminRequest() {
  const navigate = useNavigate()

  const params = useParams()
  const requestId = params?.id

  const [request, setRequest] = useState()
  const [companies, setCompanies] = useState([])
  const [selectedCompanies, setSelectedCompanies] = useState([])
  const [searchQuery, setSearchQuery] = useState('')

  const [sendRequestsLoader, setSendRequestsLoader] = useState(false)

  const selectCompany = company => {
    const companyAlreadySelected = selectedCompanies.find(
      c => c.id === company.id,
    )
    if (companyAlreadySelected) {
      return
    }

    setSelectedCompanies([...selectedCompanies, company])
    document.getElementsByName('companySearchInput')[0].value = ''
    setSearchQuery('')
  }

  const removeSelectedCompany = companyId => {
    setSelectedCompanies(prev =>
      prev.filter(company => company.id !== companyId),
    )
  }

  const sendRequests = async () => {
    if (!requestId) {
      return
    }

    setSendRequestsLoader(true)
    // send requests to companies
    const userIds = selectedCompanies.map(c => c.user_id)

    const response = await conversationsService.createAdminRequestConversation({
      requestId,
      userIds,
    })

    if (response.isOk) {
      toast.success('Zahtjev poslan!')
    } else {
      toast.error(response?.message)
    }

    setSendRequestsLoader(false)
  }

  const debounced = useDebouncedCallback(value => {
    setSearchQuery(value)
  }, 500)

  useEffect(() => {
    const getRequest = async () => {
      const response = await requestService.getRequest({ id: requestId })
      if (response.isOk) {
        setRequest(response.data)
      }
    }

    if (requestId) {
      getRequest()
    }
  }, [requestId])

  let company = request?.sender?.company
  const companyAddress = useMemo(() => {
    let fullAddress = ''

    if (!company) {
      return fullAddress
    }

    if (company.address) {
      fullAddress = `${company.address}`
    }
    if (company.zip_code) {
      fullAddress = `${fullAddress}, ${company.zip_code}`
    }
    if (company.city) {
      fullAddress = `${fullAddress}, ${company.city}`
    }

    return fullAddress
  }, [company])

  useEffect(() => {
    const searchCompanies = async name => {
      if (name.length > 2) {
        const response = await companyService.searchCompanies(name)
        console.log('send')
        if (response.isOk) {
          setCompanies(response.data)
        }
      } else {
        setCompanies([])
      }
    }

    searchCompanies(searchQuery)
  }, [searchQuery])

  return (
    <div id="admin-request">
      <div className="group-wrapper">
        <div>
          {request ? moment(request.updated_at).format('DD.MM.YYYY') : ''}
        </div>
        <h6 className="mt-1">{request?.title}</h6>
      </div>

      <div className="group-wrapper">
        <div className="fw-bold">Detalji</div>
        <p className="">{request?.details}</p>
      </div>

      <div className="group-wrapper">
        {request?.quantity ? (
          <>
            <div>
              <span className="fw-bold me-2">Količina:</span>
              <span>{request.quantity}</span>
            </div>

            <div>
              <span className="fw-bold me-2">Tip dobavljača:</span>
              <span>{request.supplier_type}</span>
            </div>
          </>
        ) : null}
      </div>

      {request?.sender ? (
        <div className="group-wrapper d-flex flex-row">
          <div className="flex-grow-1">
            <div className="fw-bold">{`Korisnik`}</div>
            <div>{`${request.sender.first_name} ${request.sender.last_name}`}</div>
            <div>{request.sender.email}</div>
            <div>{`Registrovan: ${moment(request.sender.created_at).format('DD.MM.YYYY.')}`}</div>
          </div>

          {company ? (
            <div className="flex-grow-1">
              <div className="fw-bold">{`Firma`}</div>
              <div>
                <a
                  className="fs-6 fw-bold text-decoration-none"
                  target="_blank"
                  href={`/firma/${company.id}`}>{`${company.name}`}</a>
              </div>
              <div>{`Adresa: ${companyAddress}`}</div>
              <div>{`Broj uposlenih: ${company.num_of_employees}`}</div>
              <div>{`Vrsta: ${company.type}`}</div>
            </div>
          ) : null}
        </div>
      ) : null}

      <div className="d-flex flex-column flex-lg-row mt-3">
        <div className="w-100 w-lg-50 m-1">
          <input
            name="companySearchInput"
            type="text"
            className="form-control"
            placeholder="Ime firme..."
            onChange={e => debounced(e.target.value)}
          />

          {companies.length > 0 && (
            <div
              className="search-results"
              style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {companies.map(company => (
                <div
                  key={company.id}
                  className="p-1 hover-bg-light cursor-pointer"
                  onClick={() => selectCompany(company)}>
                  {company.name}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="w-100 w-lg-50 m-1 ms-3">
          <div>{`Odabrane firme:`}</div>
          {selectedCompanies.length > 0 && (
            <div className="mt-2">
              {selectedCompanies.map(company => (
                <div key={company.id} className="selected-company">
                  <a
                    className="fs-6 fw-bold text-decoration-none"
                    target="_blank"
                    href={`/firma/${company.id}`}>{`${company.name}`}</a>
                  <IoMdClose
                    onClick={() => removeSelectedCompany(company.id)}
                  />
                </div>
              ))}

              <Button className="mt-2 submit-button" onClick={sendRequests}>
                {sendRequestsLoader ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  'Pošalji zahtjev'
                )}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
